export default __webpack_public_path__ + "static/media/logo_cortina_white.bfbbd8ee.png";